/* Owner round 4: the guide is a small link on the subtitle's line that opens a popover. */
.howLink {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--action-text);
  font: inherit;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
}

.howLink:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.howLink:focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
  border-radius: var(--radius-small);
}

.guide {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-3) var(--space-4);
}

.guideTitle {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.guideBody {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-13);
}

.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding-inline-start: var(--space-4);
  font-size: var(--font-size-13);
}
